export class Sucursal{
    public id:number;
    public nombre:string;
    public direccion:string;
    public telefono:string;
    public latitud:string;
    public longitud:string;
    constructor(){
        this.id = 0;
        this.nombre = "";
        this.direccion = "";
        this.telefono = "";
        this.latitud = "";
        this.longitud = "";
     }
}
